// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wX2278AIaa4yMYMiAAu4{cursor:pointer;align-items:center;gap:8px;min-height:32px;padding:8px;display:flex}.wX2278AIaa4yMYMiAAu4:hover{background:var(--background-neutral-subtle);border-radius:6px}.wX2278AIaa4yMYMiAAu4 .FmqrgnsSxkGcAk37vZYg{margin-left:auto}.cGMceblS5WEGgONk7m3R{opacity:.5;cursor:default}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `wX2278AIaa4yMYMiAAu4`,
	"tooltip": `FmqrgnsSxkGcAk37vZYg`,
	"disabled": `cGMceblS5WEGgONk7m3R`
};
export default ___CSS_LOADER_EXPORT___;
